import axios from 'axios'
import Store from 'store'
import { attachDeviceHeader } from './deviceHeader'

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_ENDPOINT,
})

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      Store.clearAll()
      window.location.href = '/login'
    }
    return Promise.reject(error)
  },
)

apiClient.interceptors.request.use((config) => {
  const token = Store.get('aff-tok')
  if (token) {
    config.headers = config.headers || {}
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return attachDeviceHeader(config)
})

export default apiClient
